import React from "react";

import PageLayout from "$src/core/components/templates/PageLayout";
import UpsertProfilePage from "$src/core/pages/UpsertProfilePage/UpsertProfilePage";

const Route: React.FC = () => (
  <PageLayout>
    <UpsertProfilePage />
  </PageLayout>
);

export default Route;
